(function ($) {
    // Mobile menu toggle functionality
    $(document).ready(function () {
        // Toggle mobile menu when menu-toggle button is clicked
        $('.menu-toggle').on('click', function () {
            $('.menu-mobile').addClass('active');
            console.log('Mobile menu opened');

            $('body').addClass('menu-opened');
        });

        // Close mobile menu when close button is clicked
        $('.menu-mobile__close').on('click', function () {
            $('.menu-mobile').removeClass('active');
            $('body').removeClass('menu-opened');
        });

        // Close menu when clicking outside
        $(document).on('click', function (event) {
            if (!$(event.target).closest('.menu-mobile').length &&
                !$(event.target).closest('.menu-toggle').length &&
                $('.menu-mobile').hasClass('active')) {
                $('.menu-mobile').removeClass('active');
                $('body').removeClass('menu-opened');
            }
        });

        // Login form toggle
        $('.js-login-popup-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-login-popup').addClass('is-active');
            $('.js-password-popup').removeClass('is-active');
            $('.js-password-received-popup').removeClass('is-active');
        });

        $('.js-login-popup-close').on('click', function (e) {
            e.preventDefault();
            $('.js-login-popup').removeClass('is-active');
        });

        $('.js-login-popup').on('click', function (e) {
            if ($(e.target).hasClass('js-login-popup')) {
                e.preventDefault();
                $('.js-login-popup').removeClass('is-active');
            }
        });

        // Forget password form toggle
        $('.js-password-popup-toggle').on('click', function (e) {
            e.preventDefault();
            $('.js-password-popup').addClass('is-active');
            $('.js-login-popup').removeClass('is-active');
        });

        $('.js-password-popup-close').on('click', function (e) {
            e.preventDefault();
            $(".js-password-popup").removeClass("is-active");
        });

        $('.js-password-popup').on('click', function (e) {
            if ($(e.target).hasClass('js-password-popup')) {
                e.preventDefault();
                $(".js-password-popup").removeClass("is-active");
            }
        });

        $('.js-password-received-popup-close').on('click', function (e) {
            e.preventDefault();
            $(".js-password-received-popup").removeClass("is-active");
        });

        $('.js-password-received-popup').on('click', function (e) {
            if ($(e.target).hasClass('js-password-received-popup')) {
                e.preventDefault();
                $(".js-password-received-popup").removeClass("is-active");
            }
        });

        $(".js-password-reset-popup-close").on("click", function (e) {
            e.preventDefault();
            $(".js-password-reset-popup").removeClass("is-active");
        });

        $(".js-password-reset-popup").on("click", function (e) {
            if ($(e.target).hasClass("js-password-reset-popup")) {
                e.preventDefault();
                $(".js-password-reset-popup").removeClass("is-active");
            }
        });

        // User profile menu
        $('.js-user-profile').on('click', function (e) {
            $('.js-account-menu').toggleClass('active');
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('.js-account-menu').length &&
                !$(event.target).closest('.js-user-profile').length) {
                $('.js-account-menu').removeClass('active');
            }
        });

        // Lost password form
        $("#lost-password-form").on("submit", function (e) {
            e.preventDefault();

            var userLogin = $("#user-login").val();
            var $submitBtn = $("#lost-password-form #wp-submit");
            $(".js-password-popup").addClass('saving');
            $submitBtn.val("Sending Request");
            $submitBtn.prop('disabled', true);

            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php", // or localized URL from wp_localize_script
                data: {
                    action: "lost_password",
                    user_login: userLogin,
                },
                success: function (response) {
                    if (response.success) {
                        $(".js-password-popup").removeClass("is-active");
                        $(".js-password-received-popup").addClass("is-active");
                    } else {
                        $(".js-password-error").text(response.data.message);
                    }
                },
                error: function (xhr) {
                    const errorMsg =
                    xhr.responseJSON?.data?.message || "Something went wrong, please try again later!";
                    $(".js-password-error").text(errorMsg);
                },
                complete: function () {
                    $(".js-password-popup").removeClass("saving");
                    $submitBtn.val("Reset Password");
                    $submitBtn.prop('disabled', false);
                }
            });
        });


        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("reset_password") === "1") {
            const login = urlParams.get("login");
            const key = urlParams.get("key");

            $("#reset_login").val(login);
            $("#reset_key").val(key);
            $(".js-password-reset-popup").addClass('is-active');
        }

        $("#reset-password-form").on("submit", function (e) {
            e.preventDefault();

            const pass = $("#new_pass").val();
            const confirm = $("#confirm_pass").val();

            if (pass !== confirm) {
                $("#reset-password-message").text("Passwords do not match.");
                return;
            }

            $.ajax({
                type: "POST",
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: "ajax_reset_password",
                    login: $("#reset_login").val(),
                    key: $("#reset_key").val(),
                    new_pass: pass,
                },
                success: function (res) {
                    if (res.success) {
                        setTimeout(function() {
                            window.location.href = res.data.redirect;
                        }, 1000);
                    }
                    $("#reset-password-message").text(res.data.message);
                },
                error: function (xhr) {
                    const msg = xhr.responseJSON?.data?.message || "Reset failed";
                    $("#reset-password-message").text(msg);
                },
            });
        });
    });
    /* Max Mega Menu 
     * Close the mobile menu as soon as a menu item is clicked */
    jQuery("ul.max-mega-menu").on("after_mega_menu_init", function () {
        jQuery("li.mega-menu-item-has-children").on('click', function (e) {
            $(this).siblings("li.mega-menu-item-has-children").removeClass('mega-toggle-on');
        });
    });

})(jQuery);
